module.exports = __webpack_public_path__ + "img/01_sub_no.632061e0.svg";